import React from 'react';
import UnifiedTicketTemplate from './UnifiedTicketTemplate';
import { TicketData } from '../TicketDetail';

interface ServiceRequestDetailTemplateProps {
  ticket: TicketData;
  isReadOnly: boolean;
  activeTab: 'details' | 'approvals' | 'notes' | 'activity' | 'assessment' | 'resolution' | 'attachments';
  setActiveTab: (tab: 'details' | 'approvals' | 'notes' | 'activity' | 'assessment' | 'resolution' | 'attachments') => void;
  onRefresh: () => void;
}

const ServiceRequestDetailTemplate: React.FC<ServiceRequestDetailTemplateProps> = (props) => {
  return <UnifiedTicketTemplate {...props} />;
};

export default ServiceRequestDetailTemplate;